/* Rod Armour Rebuy Smart Cart owner.
   Configuration is injected via window.RA_REBUY before this file loads. */
;(function () {
  var LURESHIELD_VARIANT_ID = 46467509354635;
  var LURESHIELD_HANDLE = 'lureshield-fishing-lure-cover';
  var LURESHIELD_JA_TITLE = '\u30eb\u30a2\u30fc\u30b7\u30fc\u30eb\u30c9 \u30eb\u30a2\u30fc\u30ab\u30d0\u30fc';
  var fallbackVersion = 'lureshield-tier-early-sync-v10';

  if (window.__raLureShieldTierEarlySync === fallbackVersion) return;
  window.__raLureShieldTierEarlySync = fallbackVersion;
  window.__raLureShieldTierFallback = 'lureshield-tier-theme-fallback-v1';
  document.documentElement.setAttribute('data-ra-rebuy-tier-sync', fallbackVersion);

  function isJapanese() {
    return /^\/ja(?:\/|$)/.test(window.location.pathname) ||
      String(document.documentElement.getAttribute('lang') || '').toLowerCase().indexOf('ja') === 0;
  }

  function money(cents) {
    return '¥' + Math.round(Number(cents || 0) / 100).toLocaleString('ja-JP');
  }

  function parseMoneyToCents(text) {
    var numeric = String(text || '').replace(/[^\d.-]/g, '');
    return numeric ? Math.round(Number(numeric) * 100) : 0;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[char];
    });
  }

  function hiddenText(text) {
    return '<span class="sr-only" style="display:none!important">' + escapeHtml(text) + '</span>';
  }

  function syncLureShieldTitle(item) {
    if (!item || !isJapanese()) return;
    if (!item.classList.contains('product-' + LURESHIELD_HANDLE) &&
      !/LureShield|\u30eb\u30a2\u30fc|\u30b7\u30fc\u30eb\u30c9/i.test(item.textContent || '')) return;

    var title = item.querySelector('.rebuy-cart__flyout-item-product-title') ||
      item.querySelector('.rebuy-cart__flyout-item-title') ||
      item.querySelector('.rebuy-product-title') ||
      item.querySelector('a');

    if (title && title.textContent.trim() !== LURESHIELD_JA_TITLE) {
      title.textContent = LURESHIELD_JA_TITLE;
    }
  }

  function tierDiscount(qty) {
    if (qty >= 15) return 25;
    if (qty >= 10) return 15;
    if (qty >= 5) return 10;
    return 0;
  }

  function tierMessage(qty) {
    var discount = tierDiscount(qty);
    if (!discount) return '';
    return isJapanese()
      ? '\u30eb\u30a2\u30fc\u30b7\u30fc\u30eb\u30c9 ' + qty + '\u500b\u4ee5\u4e0a\u3067' + discount + '%OFF'
      : 'LureShield Buy ' + qty + '+ Get ' + discount + '% Off';
  }

  function discountTitle(line) {
    if (!line) return '';
    var discount = Array.isArray(line.discounts) && line.discounts[0];
    var allocation = Array.isArray(line.line_level_discount_allocations) &&
      line.line_level_discount_allocations[0];
    var title = discount && discount.title ||
      allocation && allocation.discount_application && allocation.discount_application.title ||
      '';

    if (!isJapanese()) return title;

    return {
      'LureShield Buy 5+ Get 10% Off': '\u30eb\u30a2\u30fc\u30b7\u30fc\u30eb\u30c9 5\u500b\u4ee5\u4e0a\u306710%OFF',
      'LureShield Buy 10+ Get 15% Off': '\u30eb\u30a2\u30fc\u30b7\u30fc\u30eb\u30c9 10\u500b\u4ee5\u4e0a\u306715%OFF',
      'LureShield Buy 15+ Get 25% Off': '\u30eb\u30a2\u30fc\u30b7\u30fc\u30eb\u30c9 15\u500b\u4ee5\u4e0a\u306725%OFF'
    }[title] || title;
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); });
  }

  function updateCart(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (response) { return response.json(); });
  }

  function addVariant(quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: LURESHIELD_VARIANT_ID, quantity: quantity }] })
    }).then(function () { return getCart(); });
  }

  function itemHandle(item) {
    var classes = String(item && item.className || '').split(/\s+/);
    for (var index = 0; index < classes.length; index += 1) {
      if (classes[index].indexOf('product-') === 0) return classes[index].replace('product-', '');
    }
    return '';
  }

  function lineQuantity(cart, handle) {
    return (cart.items || []).reduce(function (total, line) {
      return total + (line.handle === handle ? Number(line.quantity || 0) : 0);
    }, 0);
  }

  function lureShieldQuantity(cart) {
    return (cart.items || []).reduce(function (total, line) {
      return total + (
        Number(line.variant_id) === LURESHIELD_VARIANT_ID || line.handle === LURESHIELD_HANDLE
          ? Number(line.quantity || 0)
          : 0
      );
    }, 0);
  }

  function cartItemCount(cart) {
    var lineTotal = (cart.items || []).reduce(function (total, line) {
      return total + Number(line.quantity || 0);
    }, 0);
    return lineTotal || Number(cart.item_count || 0);
  }

  function setLoading(button, isLoading) {
    var row = button && button.closest('.ra-tier-row');
    if (!row) return;
    row.querySelectorAll('.ra-tier-btn').forEach(function (tierButton) {
      tierButton.disabled = isLoading;
      tierButton.classList.toggle('is-loading', isLoading && tierButton === button);
      if (isLoading && tierButton === button) {
        tierButton.setAttribute('aria-busy', 'true');
      } else {
        tierButton.removeAttribute('aria-busy');
      }
    });
  }

  function findLureShieldItem() {
    var items = Array.prototype.slice.call(document.querySelectorAll('#rebuy-cart .rebuy-cart__flyout-item'));
    return items.filter(function (item) {
      return item.classList.contains('product-' + LURESHIELD_HANDLE) ||
        /LureShield|\u30eb\u30a2\u30fc|\u30b7\u30fc\u30eb\u30c9/i.test(item.textContent || '');
    })[0] || null;
  }

  function syncLineLabel(item, qty) {
    var label = item && item.querySelector('.rebuy-cart__flyout-item-quantity-widget-label');
    if (!label || !qty) return;
    syncLureShieldTitle(item);
    var title = item.querySelector('.rebuy-cart__flyout-item-product-title') ||
      item.querySelector('.rebuy-cart__flyout-item-title') ||
      item.querySelector('a');
    var name = title ? title.textContent.trim() : '';
    var assistive = isJapanese() && name ? name + '\u306e\u6570\u91cf' : 'Quantity' + (name ? ' of ' + name : '');
    label.setAttribute('data-ra-qty', String(qty));
    var labelHtml = hiddenText(assistive) + String(qty);
    if (label.innerHTML !== labelHtml) {
      label.innerHTML = labelHtml;
    }
    document.documentElement.setAttribute('data-ra-rebuy-label-last', String(qty));
  }

  function syncSubtotalCount(qty) {
    var subtotalLabel = document.querySelector('#rebuy-cart .rebuy-cart__flyout-subtotal-label');
    if (!subtotalLabel || !qty) return;
    var subtotalText = isJapanese()
      ? '\u5c0f\u8a08 (' + qty + ' \u70b9)'
      : 'Subtotal (' + qty + ' ' + (qty === 1 ? 'item' : 'items') + ')';
    if (subtotalLabel.textContent !== subtotalText) {
      subtotalLabel.textContent = subtotalText;
    }
    document.documentElement.setAttribute('data-ra-rebuy-sync-count', String(qty));
  }

  function visibleCartCountWithLureShieldQty(lureShieldQty) {
    return Array.prototype.slice.call(document.querySelectorAll('#rebuy-cart .rebuy-cart__flyout-item')).reduce(function (total, item) {
      if (item.classList.contains('product-' + LURESHIELD_HANDLE)) return total + Number(lureShieldQty || 0);
      var label = item.querySelector('.rebuy-cart__flyout-item-quantity-widget-label');
      var currentQty = parseInt(label && label.innerText, 10);
      return total + (currentQty || 0);
    }, 0);
  }

  function optimisticLureShieldUi(qty) {
    var item = findLureShieldItem();
    if (!item || !qty) return;
    syncLureShieldTitle(item);
    syncLineLabel(item, qty);
    // Prices and discount labels are synchronized from Shopify cart.js below.
    syncSubtotalCount(visibleCartCountWithLureShieldQty(qty));
    document.documentElement.setAttribute('data-ra-rebuy-pending-qty', String(qty));
  }

  function quantityForItem(cart, item, itemCount) {
    var handle = itemHandle(item);
    var qty = handle ? lineQuantity(cart, handle) : 0;
    if (handle === LURESHIELD_HANDLE) {
      qty = lureShieldQuantity(cart) || qty || (itemCount === 1 ? cartItemCount(cart) : 0);
    }
    return qty;
  }

  function syncCartUi(cart) {
    if (!cart || !Array.isArray(cart.items)) return;

    var cartItems = document.querySelectorAll('#rebuy-cart .rebuy-cart__flyout-item');
    document.documentElement.setAttribute('data-ra-rebuy-sync-items', String(cartItems.length));
    cartItems.forEach(function (item, index) {
      var handle = itemHandle(item);
      var nativeQuantityLabel = item.querySelector('.rebuy-cart__flyout-item-quantity-widget-label');
      var qty = handle === LURESHIELD_HANDLE
        ? quantityForItem(cart, item, cartItems.length)
        : parseInt(nativeQuantityLabel && nativeQuantityLabel.textContent, 10) || 0;
      document.documentElement.setAttribute('data-ra-rebuy-sync-line-' + index, handle + ':' + qty);

      if (handle === LURESHIELD_HANDLE) {
        var matchingLine = (cart.items || []).filter(function (line) {
          return Number(line.variant_id) === LURESHIELD_VARIANT_ID || line.handle === LURESHIELD_HANDLE;
        })[0];
        syncLineLabel(item, qty);
        syncLureShieldTitle(item);
        var discountLine = item.querySelector('.rebuy-cart__flyout-item-discount-line');
        var discountText = discountTitle(matchingLine);
        if (discountLine) {
          if (discountLine.textContent !== discountText) {
            discountLine.textContent = discountText;
          }
          discountLine.hidden = !discountText;
        }

        var sale = item.querySelector('.rebuy-cart__flyout-item-price .rebuy-money.sale span:not(.sr-only)');
        var compare = item.querySelector('.rebuy-cart__flyout-item-price .rebuy-money.compare-at span:not(.sr-only)');
        if (matchingLine && sale) {
          sale.textContent = money(
            matchingLine.final_price || matchingLine.discounted_price || matchingLine.price
          );
        }
        if (matchingLine && compare) {
          compare.textContent = money(matchingLine.original_price || matchingLine.price);
        }
      }
    });

    var itemCount = cartItemCount(cart);
    var countText = String(itemCount || 0);
    document.documentElement.setAttribute('data-ra-rebuy-sync-count', countText);
    var subtotalLabel = document.querySelector('#rebuy-cart .rebuy-cart__flyout-subtotal-label');
    if (subtotalLabel) {
      var subtotalText = isJapanese()
        ? '\u5c0f\u8a08 (' + countText + ' \u70b9)'
        : 'Subtotal (' + countText + ' ' + (itemCount === 1 ? 'item' : 'items') + ')';
      if (subtotalLabel.textContent !== subtotalText) {
        subtotalLabel.textContent = subtotalText;
      }
    }

    var finalAmount = document.querySelector('#rebuy-cart .rebuy-cart__flyout-subtotal-final-amount span:not(.sr-only)');
    var compareAmount = document.querySelector('#rebuy-cart .rebuy-cart__flyout-subtotal-compare-amount span:not(.sr-only)');
    var finalAmountText = money(cart.total_price);
    var compareAmountText = ' ' + money(cart.original_total_price || cart.items_subtotal_price || cart.total_price);
    if (finalAmount && finalAmount.textContent !== finalAmountText) {
      finalAmount.textContent = finalAmountText;
    }
    if (compareAmount && compareAmount.textContent !== compareAmountText) {
      compareAmount.textContent = compareAmountText;
    }

    document.querySelectorAll('.cart-bubble__text-count, [data-testid="cart-bubble"], [data-cart-count], .cart-count').forEach(function (count) {
      if (count.children.length === 0) {
        if (count.textContent !== countText) {
          count.textContent = countText;
        }
        count.classList.toggle('hidden', itemCount === 0);
      }
    });
    document.querySelectorAll('.cart-bubble').forEach(function (bubble) {
      bubble.classList.toggle('visually-hidden', itemCount === 0);
    });
    document.querySelectorAll('.cart-bubble .visually-hidden').forEach(function (hidden) {
      if (isJapanese()) {
        var japaneseCountText = '\u30ab\u30fc\u30c8\u5185\u306e\u5408\u8a08\u30a2\u30a4\u30c6\u30e0\u6570: ' + countText;
        if (hidden.textContent !== japaneseCountText) {
          hidden.textContent = japaneseCountText;
        }
      } else if (/cart|item/i.test(hidden.textContent || '')) {
        var englishCountText = 'Total items in cart: ' + countText;
        if (hidden.textContent !== englishCountText) {
          hidden.textContent = englishCountText;
        }
      }
    });
    try {
      window.sessionStorage.setItem('cart-count', JSON.stringify({
        value: countText,
        timestamp: Date.now()
      }));
    } catch (error) {
      document.documentElement.setAttribute('data-ra-rebuy-cart-storage', 'unavailable');
    }
  }

  var syncTimer = 0;
  var syncInFlight = false;
  var syncQueued = false;

  function scheduleSync(delay) {
    if (syncTimer || syncInFlight) {
      syncQueued = true;
      return;
    }
    syncTimer = window.setTimeout(function () {
      syncTimer = 0;
      syncInFlight = true;
      getCart().then(function (cart) {
        document.documentElement.setAttribute('data-ra-rebuy-sync-count', String(cartItemCount(cart) || 0));
        syncCartUi(cart);
      }).catch(function (error) {
        document.documentElement.setAttribute('data-ra-rebuy-sync-error', String(error));
        console.warn('[RA Rebuy] Cart label sync failed', error);
      }).finally(function () {
        syncInFlight = false;
        if (syncQueued) {
          syncQueued = false;
          scheduleSync(150);
        }
      });
    }, delay || 250);
  }

  function setExactQuantity(qty, button) {
    setLoading(button, true);
    optimisticLureShieldUi(qty);
    return getCart()
      .then(function (cart) {
        var updates = {};
        var matches = (cart.items || []).filter(function (line) {
          return Number(line.variant_id) === LURESHIELD_VARIANT_ID || line.handle === LURESHIELD_HANDLE;
        });
        if (!matches.length) return addVariant(qty);
        matches.forEach(function (line, index) {
          updates[line.key] = index === 0 ? qty : 0;
        });
        return updateCart(updates);
      })
      .then(function (cart) {
        syncCartUi(cart);
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('rebuy:cart.change', { bubbles: true, detail: cart }));
        scheduleSync(600);
        window.setTimeout(function () { scheduleSync(250); }, 1600);
        return cart;
      })
      .catch(function (error) {
        console.error('[RA Rebuy] LureShield tier button failed', error);
      })
      .finally(function () {
        window.setTimeout(function () { setLoading(button, false); }, 350);
      });
  }

  function handleTierButtonClick(event, button) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    }
    button = button || event && event.currentTarget;
    var qty = parseInt(button && button.getAttribute('data-qty'), 10);
    if (!qty) return false;
    setExactQuantity(qty, button);
    return false;
  }

  window.RASetLSTierQty = handleTierButtonClick;
  window.RAThemeSetLSTierQty = handleTierButtonClick;

  function captureTierButtonClick(event) {
    if (event.__raLureShieldTierHandled) return;
    var button = event.target && event.target.closest && event.target.closest('.ra-tier-btn[data-vid="' + LURESHIELD_VARIANT_ID + '"]');
    if (!button) return;
    event.__raLureShieldTierHandled = true;
    document.documentElement.setAttribute('data-ra-rebuy-tier-capture', String(Date.now()) + ':' + button.getAttribute('data-qty'));
    handleTierButtonClick(event, button);
  }

  window.addEventListener('click', captureTierButtonClick, true);
  document.addEventListener('click', captureTierButtonClick, true);
  document.documentElement.setAttribute('data-ra-rebuy-tier-handler', fallbackVersion);

  window.setInterval(function () {
    if (window.RASetLSTierQty !== handleTierButtonClick) {
      window.RASetLSTierQty = handleTierButtonClick;
    }
  }, 1000);

  function bindObserver() {
    var root = document.querySelector('#rebuy-cart');
    if (!root || window.__raRebuyCartSyncObserver || typeof MutationObserver === 'undefined') return;
    window.__raRebuyCartSyncObserver = new MutationObserver(function () {
      scheduleSync(350);
    });
    window.__raRebuyCartSyncObserver.observe(root, { childList: true, subtree: true });
  }

  [
    'rebuy:smartcart.show',
    'rebuy:smartcart.ready',
    'rebuy:cart.change',
    'rebuy:cart.add',
    'rebuy:smartcart.line-item-increase',
    'rebuy:smartcart.line-item-decrease',
    'rebuy:smartcart.line-item-removed',
    'cart:updated',
    'ra:cart:synchronized'
  ].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      bindObserver();
      scheduleSync(300);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindObserver();
      scheduleSync(500);
    });
  } else {
    bindObserver();
    scheduleSync(500);
  }

  window.setInterval(function () {
    var root = document.querySelector('#rebuy-cart');
    if (!root || !(root.offsetWidth || root.offsetHeight || root.getClientRects().length)) return;
    bindObserver();
    if (root.querySelector('.rebuy-cart__flyout-item-quantity-widget-label')) {
      document.documentElement.setAttribute('data-ra-rebuy-sync-tick', String(Date.now()));
      scheduleSync(100);
    }
  }, 1000);
})();

;(function () {
  const version = 'ra-rebuy-analytics-v1';
  if (window.__raRebuyAnalyticsAudit?.version === version) return;

  const counters = {};
  const recent = new Map();

  const readCart = (detail) => {
    if (detail?.cart?.items) return detail.cart;
    if (detail?.resource?.items) return detail.resource;
    if (detail?.items) return detail;
    return window.Rebuy?.Cart?.cart || null;
  };

  const readItem = (detail) => detail?.item || detail?.product || null;

  const readWidgetId = (detail, item) => (
    detail?.widget_id ||
    detail?.widgetId ||
    detail?.widget?.id ||
    item?.properties?._widget_id ||
    null
  );

  const readVariantId = (detail, item) => (
    detail?.variant_id ||
    detail?.variantId ||
    item?.variant_id ||
    item?.variantId ||
    null
  );

  const hasRebuyAttribution = (cart) => (
    Array.isArray(cart?.items) &&
    cart.items.some((line) => (
      line?.properties?._source === 'Rebuy' ||
      Boolean(line?.properties?._widget_id)
    ))
  );

  const updateAttributionStatus = (detail) => {
    const cart = readCart(detail || {});
    const hasAttributedLine = hasRebuyAttribution(cart) || Boolean(
      document.querySelector(
        '#rebuy-cart .rebuy-cart__flyout-item.property-key-_source.property-value-rebuy,' +
        '#rebuy-cart .rebuy-cart__flyout-item[class*="property-_widget_id:"]'
      )
    );
    document.documentElement.setAttribute(
      'data-ra-rebuy-attribution',
      hasAttributedLine ? 'present' : 'missing'
    );
  };

  const publish = (eventName, sourceEvent, detail) => {
    const cart = readCart(detail);
    const item = readItem(detail);
    const widgetId = readWidgetId(detail, item);
    const variantId = readVariantId(detail, item);
    const itemCount = Number(cart?.item_count ?? detail?.itemCount ?? detail?.data?.itemCount ?? 0);
    const signature = [eventName, widgetId || '', variantId || '', itemCount].join(':');
    const now = Date.now();
    const previous = recent.get(signature) || 0;

    if (now - previous < 750) return;
    recent.set(signature, now);

    for (const [key, timestamp] of recent) {
      if (now - timestamp > 10000) recent.delete(key);
    }

    counters[eventName] = (counters[eventName] || 0) + 1;

    const payload = {
      event: eventName,
      source_event: sourceEvent,
      item_count: itemCount,
      widget_id: widgetId,
      variant_id: variantId
    };

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(payload);
    }

    window.__raRebuyAnalyticsAudit = {
      version,
      counters: { ...counters },
      last: payload
    };

    document.documentElement.setAttribute('data-ra-rebuy-analytics-version', version);
    document.documentElement.setAttribute('data-ra-rebuy-analytics-last', eventName);
    document.documentElement.setAttribute(
      'data-ra-rebuy-event-' + eventName.replace(/_/g, '-') + '-count',
      String(counters[eventName])
    );
    document.documentElement.setAttribute(
      'data-ra-rebuy-analytics-count',
      String(Object.values(counters).reduce((total, count) => total + count, 0))
    );

    if (sourceEvent === 'rebuy:cart.add') {
      document.documentElement.setAttribute('data-ra-rebuy-attribution', 'pending');
      window.setTimeout(() => updateAttributionStatus(detail), 350);
      window.setTimeout(() => updateAttributionStatus(window.Rebuy?.Cart?.cart || {}), 1400);
    }

    document.dispatchEvent(new CustomEvent('ra:analytics:rebuy', {
      bubbles: true,
      detail: payload
    }));
  };

  const events = {
    'rebuy:smartcart.show': 'ra_rebuy_cart_open',
    'rebuy.view': 'ra_rebuy_widget_view',
    'rebuy:cart.add': 'ra_rebuy_cart_add',
    'rebuy:cart.change': 'ra_rebuy_cart_change',
    'rebuy:smartcart.line-item-increase': 'ra_rebuy_line_increase',
    'rebuy:smartcart.line-item-decrease': 'ra_rebuy_line_decrease',
    'rebuy:smartcart.line-item-removed': 'ra_rebuy_line_removed',
    'ra:multi-buy:added': 'ra_multibuy_add'
  };

  for (const [sourceEvent, eventName] of Object.entries(events)) {
    document.addEventListener(sourceEvent, (event) => {
      publish(eventName, sourceEvent, event.detail || {});
    });
  }

  window.__raRebuyAnalyticsAudit = {
    version,
    counters: {},
    last: null
  };
})();
try {
(function () {
  var config = window.RA_REBUY || {};
  var themeRoutes = window.theme && window.theme.routes ? window.theme.routes : {};
  var cartRoute = config.cartRoute || themeRoutes.cartPage || '/cart';
  var cartAddRoute = config.cartAddRoute || themeRoutes.cartAdd || '/cart/add.js';
  var rebuyScriptUrl = config.scriptUrl;
  var isDesignMode = !!config.designMode;
  var rebuyLoaderPromise = null;
  var cartAddFormsInFlight = new WeakSet();
  var localizationTimer = null;
  var smartCartLocalizationObserver = null;
  var configuredText = normalizeConfiguredCopy(config.copy);
  var localizedText = {
    fr: {
      add: 'Ajouter',
      cartTitle: 'Votre panier',
      checkout: 'Procéder au paiement',
      closeCart: 'Fermer le panier',
      continueShopping: 'Continuer vos achats',
      freeGiftRemaining: function (amount, product) { return 'Plus que ' + amount + ' pour recevoir ' + product + ' gratuit !'; },
      freeShipping: 'Livraison gratuite',
      freeShippingRemaining: function (amount) { return 'Plus que ' + amount + ' pour bénéficier de la livraison gratuite !'; },
      itemPlural: 'articles',
      itemSingular: 'article',
      size: 'Taille',
      subtotal: 'Sous-total',
      youMayAlsoLike: 'Vous aimerez aussi'
    },
    de: {
      add: 'Hinzufügen',
      cartTitle: 'Warenkorb',
      checkout: 'Zur Kasse',
      closeCart: 'Warenkorb schließen',
      continueShopping: 'Weiter einkaufen',
      freeGiftRemaining: function (amount, product) { return 'Noch ' + amount + ' bis zu einem kostenlosen ' + product + '!'; },
      freeShipping: 'Kostenloser Versand',
      freeShippingRemaining: function (amount) { return 'Noch ' + amount + ' bis zum kostenlosen Versand!'; },
      itemPlural: 'Artikel',
      itemSingular: 'Artikel',
      size: 'Größe',
      subtotal: 'Zwischensumme',
      youMayAlsoLike: 'Das könnte Ihnen auch gefallen'
    },
    es: {
      add: 'Añadir',
      cartTitle: 'Tu carrito',
      checkout: 'Finalizar pedido',
      closeCart: 'Cerrar carrito',
      continueShopping: 'Seguir comprando',
      freeGiftRemaining: function (amount, product) { return 'Te faltan ' + amount + ' para conseguir ' + product + ' gratis!'; },
      freeShipping: 'Envío gratis',
      freeShippingRemaining: function (amount) { return 'Te faltan ' + amount + ' para conseguir envío gratis!'; },
      itemPlural: 'artículos',
      itemSingular: 'artículo',
      size: 'Talla',
      subtotal: 'Subtotal',
      youMayAlsoLike: 'También te puede gustar'
    },
    it: {
      add: 'Aggiungi',
      cartTitle: 'Il tuo carrello',
      checkout: 'Check-out',
      closeCart: 'Chiudi carrello',
      continueShopping: 'Continua a comprare',
      freeGiftRemaining: function (amount, product) { return 'Ti mancano ' + amount + ' per ricevere ' + product + ' gratis!'; },
      freeShipping: 'Spedizione gratuita',
      freeShippingRemaining: function (amount) { return 'Ti mancano ' + amount + ' per la spedizione gratuita!'; },
      itemPlural: 'articoli',
      itemSingular: 'articolo',
      size: 'Taglia',
      subtotal: 'Subtotale',
      youMayAlsoLike: 'Ti potrebbe piacere anche'
    },
    nl: {
      add: 'Toevoegen',
      cartTitle: 'Je winkelwagen',
      checkout: 'Afrekenen',
      closeCart: 'Winkelwagen sluiten',
      continueShopping: 'Verder winkelen',
      freeGiftRemaining: function (amount, product) { return 'Nog ' + amount + ' tot een gratis ' + product + '!'; },
      freeShipping: 'Gratis verzending',
      freeShippingRemaining: function (amount) { return 'Nog ' + amount + ' tot gratis verzending!'; },
      itemPlural: 'artikelen',
      itemSingular: 'artikel',
      size: 'Maat',
      subtotal: 'Subtotaal',
      youMayAlsoLike: 'Misschien vind je dit ook leuk'
    },
    pt: {
      add: 'Adicionar',
      cartTitle: 'O seu carrinho',
      checkout: 'Finalizar compra',
      closeCart: 'Fechar carrinho',
      continueShopping: 'Continuar a comprar',
      freeGiftRemaining: function (amount, product) { return 'Faltam ' + amount + ' para receber ' + product + ' grátis!'; },
      freeShipping: 'Envio gratuito',
      freeShippingRemaining: function (amount) { return 'Faltam ' + amount + ' para envio gratuito!'; },
      itemPlural: 'artigos',
      itemSingular: 'artigo',
      size: 'Tamanho',
      subtotal: 'Subtotal',
      youMayAlsoLike: 'Também pode gostar'
    },
    ja: {
      add: '追加',
      cartTitle: 'カート',
      checkout: 'チェックアウト',
      closeCart: 'カートを閉じる',
	      continueShopping: '買い物を続ける',
	      emptyCartBody: 'お気に入りの商品をカートに追加してください。',
	      emptyCartTitle: 'カートは空です',
	      freeGiftRemaining: function (amount, product) { return product + '無料プレゼントまであと' + amount + 'です！'; },
      freeShipping: '送料無料',
      freeShippingRemaining: function (amount) { return '送料無料まであと' + amount + 'です！'; },
	      itemPlural: '点',
	      itemSingular: '点',
	      finalPrice: '最終価格',
	      freeShippingReached: '送料無料になりました！',
	      originalPrice: '通常価格',
	      price: '価格',
	      progress: function (value) { return '進捗: ' + value; },
	      salePrice: 'セール価格',
	      shopNow: '商品を見る',
	      size: 'サイズ',
	      subtotal: '小計',
	      youMayAlsoLike: '一緒におすすめ'
	    }
  };

  if (!rebuyScriptUrl) {
    return;
  }

  if (isLocalThemePreview()) {
    return;
  }

  function isCartPage() {
    return document.body.classList.contains('template-cart') || window.location.pathname === cartRoute;
  }

  function isLocalThemePreview() {
    return window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost';
  }

  function fallbackToCartPage(error) {
    if (error && isDesignMode) {
      console.warn('Rebuy Smart Cart unavailable; falling back to cart page:', error);
    }
    if (!isCartPage()) {
      window.location.assign(cartRoute);
    }
  }

  function waitForRebuySmartCart(resolve, reject) {
    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
        window.clearInterval(timer);
        resolve(window.Rebuy);
        return;
      }
      if (attempts > 80) {
        window.clearInterval(timer);
        reject(new Error('Rebuy Smart Cart did not become ready in time.'));
      }
    }, 100);
  }

  function applyFreeShippingThreshold(RebuyInstance) {
    if (config.freeShippingThreshold == null) return RebuyInstance;
    try {
      var smartCart = RebuyInstance && RebuyInstance.SmartCart;
      if (smartCart && smartCart.config) {
        smartCart.config.free_shipping = {
          enabled: true,
          threshold: Number(config.freeShippingThreshold),
          currency: config.freeShippingCurrency || 'USD'
        };
      }
      if (window.Rebuy && window.Rebuy.config) {
        window.Rebuy.config.free_shipping_threshold = Number(config.freeShippingThreshold);
        window.Rebuy.config.free_shipping_currency = config.freeShippingCurrency || 'USD';
      }
    } catch (e) {
      if (isDesignMode) console.warn('Could not apply free-shipping threshold to Rebuy:', e);
    }
    return RebuyInstance;
  }

  function getLocaleKey() {
    var pathLocale = window.location.pathname.match(/^\/([a-z]{2})(?:-[a-z]{2})?(?:\/|$)/i);
    var locale = (pathLocale && pathLocale[1]) ||
      (window.Shopify && window.Shopify.locale) ||
      document.documentElement.getAttribute('lang') ||
      '';
    return String(locale).toLowerCase().split('-')[0];
  }

  function setElementText(element, value) {
    if (!element || !value) return;
    if (element.textContent === value) return;
    element.textContent = value;
  }

  function itemCountLabel(dictionary, count) {
    return Number(count) === 1 ? dictionary.itemSingular : dictionary.itemPlural;
  }

  function replaceTemplateValue(template, replacements) {
    if (!template) return '';
    var output = String(template);
    Object.keys(replacements).forEach(function (key) {
      output = output.split(key).join(replacements[key]);
    });
    return output;
  }

	  function normalizeConfiguredCopy(copy) {
	    if (!copy) return null;

    var dictionary = {};
    [
      'add',
      'cartTitle',
      'checkout',
      'closeCart',
	      'continueShopping',
	      'emptyCartBody',
	      'emptyCartTitle',
	      'finalPrice',
	      'freeShipping',
	      'freeShippingReached',
	      'itemPlural',
	      'itemSingular',
	      'originalPrice',
	      'price',
	      'salePrice',
	      'shopNow',
	      'size',
      'subtotal',
      'youMayAlsoLike',
      'cartAddError'
    ].forEach(function (key) {
      if (copy[key]) dictionary[key] = copy[key];
    });

    if (copy.freeShippingRemainingTemplate) {
      dictionary.freeShippingRemaining = function (amount) {
        return replaceTemplateValue(copy.freeShippingRemainingTemplate, {
          '___AMOUNT___': amount
        });
      };
    }

    if (copy.freeGiftRemainingTemplate) {
      dictionary.freeGiftRemaining = function (amount, product) {
        return replaceTemplateValue(copy.freeGiftRemainingTemplate, {
          '___AMOUNT___': amount,
          '___PRODUCT___': product
        });
      };
    }

	    return dictionary;
	  }

  function normalizeText(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  function productTitleReplacement(text) {
    if (getLocaleKey() !== 'ja') return null;

    var productTitles = {
      'LureShield Fishing Lure Cover': 'ルアーシールド ルアーカバー',
      'LureShield Fishing Lure Cover 5 Pack': 'ルアーシールド ルアーカバー 5個セット',
      'LureShield Fishing Lure Cover 10 Pack': 'ルアーシールド ルアーカバー 10個セット',
      'LureShield Fishing Lure Cover 15 Pack': 'ルアーシールド ルアーカバー 15個セット',
      'LureShield (Lure Cover)': 'ルアーシールド ルアーカバー',
      'LureShield（ルアーカバー）': 'ルアーシールド ルアーカバー',
      'Reel Armour - Spinning Reel Cover 1000-4000': 'リールアーマー スピニングリールカバー 1000-4000',
      'Reel Armour - Baitcast Reel Cover': 'リールアーマー ベイトキャストリールカバー',
      'Reel Armour（ベイトリールカバー）': 'リールアーマー ベイトキャストリールカバー',
      'Fishing Rod Sleeve Pro': 'フィッシングロッドスリーブ Pro',
      'Rod Armour Pro Sleeve（ロッドカバー）': 'フィッシングロッドスリーブ Pro',
      "'WrapStrap' Rod Strap": 'WrapStrap ロッドストラップ',
      'WrapStrap Rod Strap': 'WrapStrap ロッドストラップ',
      'WrapStrap（ロッドストラップ）': 'WrapStrap ロッドストラップ'
    };

    return productTitles[text] || null;
  }

  function commerceLabelReplacement(text, dictionary) {
    if (getLocaleKey() !== 'ja') return null;

    var labels = {
      'Price': dictionary.price,
      'Sale price': dictionary.salePrice,
      'Original price': dictionary.originalPrice,
      'Final price': dictionary.finalPrice,
      'LureShield Buy 5+ Get 10% Off': 'ルアーシールド 5個以上で10%OFF',
      'LureShield Buy 10+ Get 15% Off': 'ルアーシールド 10個以上で15%OFF',
      'LureShield Buy 15+ Get 25% Off': 'ルアーシールド 15個以上で25%OFF',
      'Reel Armour Spinning Buy 3 Get 1 Free': 'スピニングリールカバー 3個で1個無料',
      'Reel Armour Baitcaster Buy 3 Get 1 Free': 'ベイトキャストリールカバー 3個で1個無料',
      'Buy 3 Get 1 Free': '3個で1個無料'
    };

    return labels[text] || null;
  }

  function canWriteLocalizedText(element, text, canReplaceContainer) {
    if (!element) return false;
    if (element.closest && element.closest('.rebuy-cart__flyout-item-quantity-widget')) return false;
    if (element.matches([
      '#rebuy-cart',
      '.rebuy-cart',
      '.rebuy-cart__flyout',
      '.rebuy-cart__flyout-content',
      '.rebuy-cart__flyout-body',
      '.rebuy-cart__flyout-footer',
      '.rebuy-cart__flyout-items',
      '.rebuy-cart__flyout-item',
      '.rebuy-cart__flyout-item-info',
      '.rebuy-cart__flyout-recommendations',
      '.rebuy-widget',
      '.rebuy-product-block',
      '.rebuy-product-info'
    ].join(','))) {
      return false;
    }
    if ((text || '').length > 160 && !element.matches('.rebuy-cart__progress-bar-prompt')) return false;
    if (element.children.length === 0) return true;
    if (!canReplaceContainer) return false;

    return element.matches([
      '.rebuy-cart__title',
      '.rebuy-cart__progress-bar-prompt',
      '.rebuy-cart__progress-step-label',
      '.rebuy-widget .primary-title',
      '.rebuy-widget-title',
      '.rebuy-cart__checkout-button',
      '.rebuy-cart__continue-shopping-button',
      '.rebuy-cart__flyout-subtotal-label',
      '.rebuy-cart__flyout-subtotal-label span',
      '.rebuy-cart__flyout-item-product-title',
      '.rebuy-product-title',
      '.rebuy-product-title-link',
      '.rebuy-cart__flyout-item-discount-line',
      '.rebuy-cart__flyout-empty-cart h4',
      '.rebuy-cart__flyout-empty-cart p',
      '.rebuy-cart__empty-cart h4',
      '.rebuy-cart__empty-cart p',
      '.ql-align-center',
      'button',
      'a',
      'span',
      'h1',
      'h2',
      'h3',
      'h4',
      'p'
    ].join(','));
  }

  function localizeLeafText(root, dictionary) {
    if (!root || !dictionary) return;
    root.querySelectorAll('h1, h2, h3, h4, p, span, button, a, div').forEach(function (element) {
      if (element.closest && element.closest('.rebuy-cart__flyout-item-quantity-widget')) return;
      var text = normalizeText(element.textContent);
      if (!text) return;
      var lower = text.toLowerCase();
      var replacement = null;
      var canReplaceContainer = false;

      if (lower === 'login') {
        element.style.display = 'none';
        element.setAttribute('aria-hidden', 'true');
        return;
      }

      if (lower === 'your cart' || lower === 'your shopping cart') {
        replacement = dictionary.cartTitle;
        canReplaceContainer = true;
      }
      if (lower === 'free shipping') {
        replacement = dictionary.freeShipping;
        canReplaceContainer = true;
      }
      if (lower === 'you may also like' || lower === 'you might also like this') {
        replacement = dictionary.youMayAlsoLike;
        canReplaceContainer = true;
      }
      if (lower === 'checkout' || lower === 'check out' || lower === 'to checkout' || lower === 'proceed to checkout') {
        replacement = dictionary.checkout;
        canReplaceContainer = true;
      }
      if (lower === 'continue shopping') {
        replacement = dictionary.continueShopping;
        canReplaceContainer = true;
      }
      if (lower === 'your cart is empty!' && dictionary.emptyCartTitle) {
        replacement = dictionary.emptyCartTitle;
        canReplaceContainer = true;
      }
      if (lower === 'add your favorite items to your cart.' && dictionary.emptyCartBody) {
        replacement = dictionary.emptyCartBody;
        canReplaceContainer = true;
      }
      if (lower === 'shop now' && dictionary.shopNow) {
        replacement = dictionary.shopNow;
        canReplaceContainer = true;
      }
      if (lower === 'add') replacement = dictionary.add;
      if (lower === 'size') replacement = dictionary.size;
      if (lower === 'subtotal' || lower === 'cart subtotal') {
        replacement = dictionary.subtotal;
        canReplaceContainer = true;
      }

      var productTitle = productTitleReplacement(text);
      if (productTitle) {
        replacement = productTitle;
        canReplaceContainer = true;
      }

      var commerceLabel = commerceLabelReplacement(text, dictionary);
      if (commerceLabel) {
        replacement = commerceLabel;
        canReplaceContainer = true;
      }

      if (getLocaleKey() === 'ja') {
        var progressMatch = text.match(/^Progress:\s*(.+)$/i);
        if (progressMatch && dictionary.progress) {
          replacement = dictionary.progress(progressMatch[1]);
          canReplaceContainer = true;
        }

        var quantityOfMatch = text.match(/^Quantity of (.+)$/i);
        if (quantityOfMatch) {
          var quantityProductTitle = quantityOfMatch[1].replace(/\s+\d+$/, '');
          replacement = (productTitleReplacement(quantityProductTitle) || quantityProductTitle) + 'の数量';
          canReplaceContainer = true;
        }

        var openedCartMatch = text.match(/^Opening the cart\. There are (\d+) items? in your cart\.$/i);
        if (openedCartMatch) {
          replacement = 'カートを開いています。カートには' + openedCartMatch[1] + '点の商品があります。';
          canReplaceContainer = true;
        }
      }

      var subtotalWithCountMatch = text.match(/^Subtotal\s*\((\d+)\s+Items?\)$/i);
      if (subtotalWithCountMatch && dictionary.itemSingular && dictionary.itemPlural) {
        replacement = dictionary.subtotal + ' (' + subtotalWithCountMatch[1] + ' ' + itemCountLabel(dictionary, subtotalWithCountMatch[1]) + ')';
        canReplaceContainer = true;
      }

      var itemCountMatch = text.match(/^\((\d+)\s+Items?\)$/i);
      if (itemCountMatch && dictionary.itemSingular && dictionary.itemPlural) {
        replacement = '(' + itemCountMatch[1] + ' ' + itemCountLabel(dictionary, itemCountMatch[1]) + ')';
      }

      var freeShippingMatch = text.match(/^You are (.+?) away from FREE SHIPPING!?$/i);
      if (freeShippingMatch && dictionary.freeShippingRemaining) {
        replacement = dictionary.freeShippingRemaining(freeShippingMatch[1]);
        canReplaceContainer = true;
      }

      var freeShippingReachedMatch = text.match(/^(🎉\s*)?Congrats! You've unlocked FREE SHIPPING!?$/i);
      if (freeShippingReachedMatch && dictionary.freeShippingReached) {
        replacement = (freeShippingReachedMatch[1] || '') + dictionary.freeShippingReached;
        canReplaceContainer = true;
      }

      var freeGiftMatch = text.match(/^You are (.+?) away from a free (.+?)!?$/i);
      if (freeGiftMatch && dictionary.freeGiftRemaining) {
        replacement = dictionary.freeGiftRemaining(freeGiftMatch[1], freeGiftMatch[2]);
        canReplaceContainer = true;
      }

      if (replacement && canWriteLocalizedText(element, text, canReplaceContainer)) {
        setElementText(element, replacement);
      }
    });
  }

  function localizeA11yLabels(root, dictionary) {
    if (!root || getLocaleKey() !== 'ja') return;

    root.querySelectorAll('.rebuy-cart__progress-bar-meter .sr-only').forEach(function (element) {
      var progressMatch = normalizeText(element.textContent).match(/^Progress:\s*(.+)$/i);
      if (!progressMatch || !dictionary.progress) return;
      element.textContent = dictionary.progress(progressMatch[1]);
    });

    root.querySelectorAll('.rebuy-cart__flyout-item-remove').forEach(function (button) {
      var label = button.getAttribute('aria-label') || button.getAttribute('title') || normalizeText(button.textContent);
      var removeMatch = normalizeText(label).match(/^Remove\s+(.+)$/i);
      if (!removeMatch) return;
      var product = productTitleReplacement(removeMatch[1]) || removeMatch[1];
      var localizedLabel = product + 'を削除';
      button.setAttribute('aria-label', localizedLabel);
      button.setAttribute('title', localizedLabel);
    });
  }

  function syncRecommendationProductTitles(root) {
    if (!root) return;

    var titlesByHandle = getLocaleKey() === 'ja' ? {
      'fishing-rod-sleeve-pro': 'フィッシングロッドスリーブ Pro',
      'lureshield-fishing-lure-cover': 'ルアーシールド ルアーカバー',
      'lureshield-fishing-lure-cover-5-pack-1': 'ルアーシールド ルアーカバー 5個セット',
      'lureshield-fishing-lure-cover-10-pack-1': 'ルアーシールド ルアーカバー 10個セット',
      'lureshield-fishing-lure-cover-15-pack-1': 'ルアーシールド ルアーカバー 15個セット',
      'reel-armour-baitcast-reel-cover': 'リールアーマー ベイトキャストリールカバー',
      'reel-armour-spinning-reel-cover': 'リールアーマー スピニングリールカバー',
      'wrapstrap-rod-strap': 'WrapStrap ロッドストラップ'
    } : {
      'fishing-rod-sleeve-pro': 'Fishing Rod Sleeve Pro',
      'lureshield-fishing-lure-cover': 'LureShield Fishing Lure Cover',
      'lureshield-fishing-lure-cover-5-pack-1': 'LureShield Fishing Lure Cover 5 Pack',
      'lureshield-fishing-lure-cover-10-pack-1': 'LureShield Fishing Lure Cover 10 Pack',
      'lureshield-fishing-lure-cover-15-pack-1': 'LureShield Fishing Lure Cover 15 Pack',
      'reel-armour-baitcast-reel-cover': 'Reel Armour - Baitcast Reel Cover',
      'reel-armour-spinning-reel-cover': 'Reel Armour - Spinning Reel Cover 1000-4000',
      'wrapstrap-rod-strap': 'WrapStrap Rod Strap'
    };

    root.querySelectorAll('.rebuy-product-block').forEach(function (card) {
      var productLink = card.querySelector('a[href*="/products/"]');
      var title = card.querySelector('.rebuy-product-title');
      var match = productLink && productLink.getAttribute('href').match(/\/products\/([^/?#]+)/);
      var localizedTitle = match && titlesByHandle[match[1]];
      if (title && localizedTitle && title.textContent.trim() !== localizedTitle) {
        title.textContent = localizedTitle;
      }
    });
  }

  function localizeStorefrontDiscountTitles(dictionary) {
    if (getLocaleKey() !== 'ja' || !dictionary) return;

    document.querySelectorAll('main li').forEach(function (element) {
      if (element.children.length !== 0) return;
      var text = normalizeText(element.textContent);
      var replacement = commerceLabelReplacement(text, dictionary);
      if (replacement && replacement !== text) {
        element.textContent = replacement;
      }
    });
  }

  function localizeSmartCart() {
    var fallbackDictionary = localizedText[getLocaleKey()] || {};
    var dictionary = configuredText ? Object.assign({}, fallbackDictionary, configuredText) : fallbackDictionary;
    var root = document.getElementById('rebuy-cart');
    if (!dictionary) return;
    localizeStorefrontDiscountTitles(dictionary);
    if (!root) return;

    var title = root.querySelector('.rebuy-cart__title, #rebuy-cart-title, [data-rebuy-component="title-bar"]');
    var close = root.querySelector('.rebuy-cart__flyout-close, #rebuy-cart-close');
    localizeLeafText(root, dictionary);
    localizeA11yLabels(root, dictionary); syncRecommendationProductTitles(root);

    if (title && (title.textContent || '').replace(/\s+/g, ' ').trim() === 'Your Cart') {
      title.textContent = dictionary.cartTitle;
    }
    if (close) {
      close.setAttribute('aria-label', dictionary.closeCart);
      close.setAttribute('title', dictionary.closeCart);
      close.textContent = '×';
    }
  }

  function ensureSmartCartLocalizationObserver() {
    if (smartCartLocalizationObserver || !window.MutationObserver || !document.body) return;

    smartCartLocalizationObserver = new MutationObserver(function () {
      syncRecommendationProductTitles(document.getElementById('rebuy-cart'));
      window.clearTimeout(localizationTimer);
      localizationTimer = window.setTimeout(localizeSmartCart, 80);
    });
    smartCartLocalizationObserver.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function scheduleSmartCartLocalization() {
    ensureSmartCartLocalizationObserver();
    window.clearTimeout(localizationTimer);
    localizationTimer = window.setTimeout(function () {
      localizeSmartCart();
      window.setTimeout(localizeSmartCart, 80);
      window.setTimeout(localizeSmartCart, 350);
      window.setTimeout(localizeSmartCart, 900);
      window.setTimeout(localizeSmartCart, 1800);
      window.setTimeout(localizeSmartCart, 3500);
    }, 0);
  }

  function loadRebuy() {
    if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
      return Promise.resolve(applyFreeShippingThreshold(window.Rebuy));
    }
    if (rebuyLoaderPromise) {
      return rebuyLoaderPromise;
    }
    rebuyLoaderPromise = new Promise(function (resolve, reject) {
      var isRebuyPreview = false;
      try {
        isRebuyPreview = new URLSearchParams(window.location.search).has('preview_smart_cart');
      } catch (error) {
        isRebuyPreview = window.location.search.indexOf('preview_smart_cart=') !== -1;
      }
      if (isRebuyPreview) {
        waitForRebuySmartCart(function (R) { resolve(applyFreeShippingThreshold(R)); }, reject);
        return;
      }
      var existing = document.querySelector(
        'script[data-ra-rebuy-loader], script[src*="cdn.rebuyengine.com/onsite/js/rebuy.js"]'
      );
      if (existing) {
        waitForRebuySmartCart(function (R) { resolve(applyFreeShippingThreshold(R)); }, reject);
        return;
      }
      var script = document.createElement('script');
      script.src = rebuyScriptUrl;
      script.async = true;
      script.setAttribute('data-ra-rebuy-loader', 'true');
      script.addEventListener('load', function () {
        waitForRebuySmartCart(function (R) { resolve(applyFreeShippingThreshold(R)); }, reject);
      }, { once: true });
      script.addEventListener('error', function () { reject(new Error('Failed to load Rebuy.')); }, { once: true });
      document.head.appendChild(script);
    }).catch(function (error) {
      rebuyLoaderPromise = null;
      throw error;
    });
    return rebuyLoaderPromise;
  }

  function hideNativeCartDrawer() {
    var drawer = document.getElementById('CartDrawer');
    if (drawer) {
      drawer.setAttribute('hidden', '');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.classList.remove('drawer--is-open', 'is-transitioning');
    }
    document.querySelectorAll('cart-drawer-component dialog[open], .cart-drawer__dialog[open]').forEach(function (dialog) {
      try {
        if (typeof dialog.close === 'function') {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
        }
      } catch (error) {
        dialog.removeAttribute('open');
      }
      dialog.setAttribute('aria-hidden', 'true');
    });
    if (document.body) {
      document.body.classList.remove('js-drawer-open-cart', 'drawer--is-open');
    }
    document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open-cart', 'lock-scroll');
  }

  function getCartTriggerSelector() {
    return '[data-ra-rebuy-cart-trigger], [data-testid="cart-drawer-trigger"], .js-drawer-open-cart, [aria-controls="CartDrawer"], a[href="' + cartRoute + '"], a[href$="/cart"]';
  }

  function normalizeCartTriggers() {
    document.querySelectorAll(getCartTriggerSelector()).forEach(function (el) {
      if (el.getAttribute('data-testid') === 'cart-drawer-trigger' || el.getAttribute('href') === cartRoute || el.classList.contains('js-drawer-open-cart') || el.getAttribute('aria-controls') === 'CartDrawer') {
        el.classList.remove('js-drawer-open-cart');
        el.removeAttribute('aria-controls');
        el.setAttribute('data-ra-rebuy-cart-trigger', 'true');
      }
    });
    hideNativeCartDrawer();
  }

  function isRebuyCartVisible() {
    var rebuyCart = document.getElementById('rebuy-cart');
    var rebuyFlyout = document.querySelector('.rebuy-cart__flyout');
    var flyoutRect = rebuyFlyout ? rebuyFlyout.getBoundingClientRect() : null;
    var flyoutStyle = rebuyFlyout ? window.getComputedStyle(rebuyFlyout) : null;
    return !!(rebuyCart &&
      rebuyFlyout &&
      rebuyCart.classList.contains('is-visible') &&
      rebuyCart.getAttribute('aria-hidden') === 'false' &&
      flyoutStyle &&
      flyoutStyle.display !== 'none' &&
      flyoutStyle.visibility !== 'hidden' &&
      flyoutRect &&
      flyoutRect.width > 0 &&
      flyoutRect.height > 0 &&
      flyoutRect.right > 0 &&
      flyoutRect.left < window.innerWidth &&
      flyoutRect.bottom > 0 &&
      flyoutRect.top < window.innerHeight);
  }

  function showRebuyCartWhenReady(RebuyInstance) {
    var attempts = 0;
    var smartCart = RebuyInstance && RebuyInstance.SmartCart;
    return new Promise(function (resolve, reject) {
      (function showAndCheck() {
        hideNativeCartDrawer();
        if (smartCart && typeof smartCart.show === 'function') {
          smartCart.show();
        }
        if (isRebuyCartVisible()) {
          scheduleSmartCartLocalization();
          resolve();
          return;
        }
        attempts += 1;
        if (attempts > 80) {
          reject(new Error('Rebuy Smart Cart did not become visible in time.'));
          return;
        }
        window.setTimeout(showAndCheck, 100);
      })();
    });
  }

  function openRebuyCart() {
    if (isCartPage()) {
      return Promise.resolve();
    }
    normalizeCartTriggers();
    return loadRebuy()
      .then(showRebuyCartWhenReady)
      .catch(fallbackToCartPage);
  }

  function queueOpenRebuyCart() {
    window.clearTimeout(queueOpenRebuyCart.timer);
    queueOpenRebuyCart.timer = window.setTimeout(openRebuyCart, 0);
  }

  function stopCartEvent(event) {
    if (!event) return;
    if (typeof event.preventDefault === 'function') event.preventDefault();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
      return;
    }
    if (typeof event.stopPropagation === 'function') event.stopPropagation();
  }

  function isProductCartEvent(event) {
    var target = event && event.target;
    return !!(target && target.closest && (
      target.closest('.product-section') ||
      target.closest('product-form') ||
      target.closest('form[action*="/cart/add"]')
    ));
  }

  function getCartAddForm(target) {
    if (!target || !target.closest) {
      return null;
    }
    var form = target.closest('form');
    if (!form) {
      return null;
    }
    var action = form.getAttribute('action') || '';
    return action.indexOf('/cart/add') !== -1 ? form : null;
  }

  function getSubmitButton(form) {
    if (!form) {
      return null;
    }
    return form.querySelector('[type="submit"], .add-to-cart, .grid-product__atc-btn, .ra-best-match__atc');
  }

  function setCartAddLoading(form, isLoading) {
    var submitButton = getSubmitButton(form);
    if (!submitButton) {
      return;
    }
    submitButton.classList.toggle('btn--loading', isLoading);
    submitButton.classList.toggle('product-form__submit-button--pulsing', isLoading);
    submitButton.disabled = isLoading;
  }

  function parseCartAddResponse(response) {
    return response.text().then(function (text) {
      var data = null;
      if (text) {
        try {
          data = JSON.parse(text);
        } catch (error) {
          if (response.ok) {
            throw { description: 'Cart add returned an unreadable response. Please open the product page and try again.' };
          }
        }
      }
      if (!response.ok || (data && data.status === 422)) {
        if (isLocalThemePreview()) {
          throw { description: 'Shopify blocks cart adds on this local preview. Use the Shopify preview URL to test Add to Cart.' };
        }
        if (data) {
          throw data;
        }
        throw { description: 'Cart add failed. Please open the product page and try again.' };
      }
      if (!data) {
        throw { description: 'Cart add returned an empty response. Please open the product page and try again.' };
      }
      return data;
    });
  }

  function showCartAddError(form, error) {
    if (!form) {
      return;
    }
    var message = error && (error.description || error.message);
    if (!message) {
      message = configuredText && configuredText.cartAddError ? configuredText.cartAddError : 'Sorry, this item could not be added to cart.';
    }
    var existing = form.querySelector('.errors.ra-rebuy-cart-error');
    if (existing) {
      existing.remove();
    }
    var errorEl = document.createElement('div');
    errorEl.className = 'errors text-center ra-rebuy-cart-error';
    errorEl.textContent = typeof message === 'string'
      ? message
      : (configuredText && configuredText.cartAddError ? configuredText.cartAddError : 'Sorry, this item could not be added to cart.');
    form.appendChild(errorEl);
  }

  function handleCartAddSubmit(event) {
    if (isCartPage()) {
      return;
    }
    var form = getCartAddForm(event.target);
    if (!form || form.hasAttribute('data-ra-native-cart-submit')) {
      return;
    }
    if (form.closest('product-form-component') || form.classList.contains('shopify-product-form')) {
      return;
    }
    stopCartEvent(event);
    if (cartAddFormsInFlight.has(form)) {
      return;
    }
    cartAddFormsInFlight.add(form);
    setCartAddLoading(form, true);
    fetch(cartAddRoute, {
      method: 'POST',
      body: new FormData(form),
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(parseCartAddResponse)
      .then(function (product) {
        var submitButton = getSubmitButton(form);
        var eventDetail = {
          product: product,
          addToCartBtn: submitButton
        };
        form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: eventDetail,
          bubbles: true
        }));
        queueOpenRebuyCart();
      })
      .catch(function (error) {
        showCartAddError(form, error);
      })
      .finally(function () {
        cartAddFormsInFlight.delete(form);
        setCartAddLoading(form, false);
      });
  }

  function handleProductFormCartNavigation(event) {
    if (!isProductCartEvent(event) || isCartPage()) return;
    stopCartEvent(event);
    queueOpenRebuyCart();
  }

  function handleCartTriggerClick(event) {
    var target = event.target;
    var trigger = target && target.closest && target.closest(getCartTriggerSelector());
    if (!trigger || isCartPage()) return;
    stopCartEvent(event);
    openRebuyCart();
  }

  function init() {
    var currentUrl = new URL(window.location.href);
    if (currentUrl.searchParams.get('viewcart') === 'true' && currentUrl.pathname !== cartRoute) {
      currentUrl.searchParams.delete('viewcart');
      window.history.replaceState({}, document.title, currentUrl.toString());
      openRebuyCart();
    }

    normalizeCartTriggers();
    document.addEventListener('submit', handleCartAddSubmit, true);
    document.addEventListener('click', handleCartTriggerClick, true);
    document.addEventListener('product-form:cart:navigate', handleProductFormCartNavigation, true);
    document.addEventListener('product-form:submit:success', function (event) {
      if (!isProductCartEvent(event) || isCartPage()) return;
      queueOpenRebuyCart();
    }, true);
    document.addEventListener('product-form:cart:update', function (event) {
      if (!isProductCartEvent(event) || isCartPage()) return;
      queueOpenRebuyCart();
    }, true);
    document.addEventListener('ajaxProduct:added', function () {
      if (!isCartPage()) {
        queueOpenRebuyCart();
      }
    }, true);
    document.addEventListener('ra:cart:open', function (event) {
      if (isCartPage()) return;
      stopCartEvent(event);
      openRebuyCart();
    }, true);
    document.addEventListener('cart:open', function (event) {
      if (isCartPage()) return;
      stopCartEvent(event);
      openRebuyCart();
    }, true);
    document.addEventListener('rebuy:smartcart.show', scheduleSmartCartLocalization);
    document.addEventListener('rebuy:cart.change', scheduleSmartCartLocalization);
    document.addEventListener('rebuy:smartcart.ready', scheduleSmartCartLocalization);
    document.addEventListener('page:loaded', normalizeCartTriggers);
    document.addEventListener('shopify:section:load', normalizeCartTriggers);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
} catch (error) {
  console.warn('[RA Rebuy] Main helper failed; tier fallback remains active', error);
}

// Rebuy can render promo buttons before its ready callback binds; keep the
// tier buttons functional from the theme layer as a fallback.
;(function () {
  var LURESHIELD_VARIANT_ID = 46467509354635;
  var LURESHIELD_HANDLE = 'lureshield-fishing-lure-cover';
  var LURESHIELD_JA_TITLE = '\u30eb\u30a2\u30fc\u30b7\u30fc\u30eb\u30c9 \u30eb\u30a2\u30fc\u30ab\u30d0\u30fc';
  var bindVersion = 'lureshield-tier-theme-fallback-v1';

  if (window.__raLureShieldTierFallback === bindVersion) return;
  window.__raLureShieldTierFallback = bindVersion;

  function isJapanese() {
    return /^\/ja(?:\/|$)/.test(window.location.pathname) ||
      String(document.documentElement.getAttribute('lang') || '').toLowerCase().indexOf('ja') === 0;
  }

  function money(cents) {
    return '¥' + Math.round(Number(cents || 0) / 100).toLocaleString('ja-JP');
  }

  function parseMoneyToCents(text) {
    var numeric = String(text || '').replace(/[^\d.-]/g, '');
    return numeric ? Math.round(Number(numeric) * 100) : 0;
  }

  function tierDiscount(qty) {
    if (qty >= 15) return 25;
    if (qty >= 10) return 15;
    if (qty >= 5) return 10;
    return 0;
  }

  function tierMessage(qty) {
    var discount = tierDiscount(qty);
    if (!discount) return '';
    return isJapanese()
      ? '\u30eb\u30a2\u30fc\u30b7\u30fc\u30eb\u30c9 ' + qty + '\u500b\u4ee5\u4e0a\u3067' + discount + '%OFF'
      : 'LureShield Buy ' + qty + '+ Get ' + discount + '% Off';
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[char];
    });
  }

  function visuallyHiddenText(text) {
    return '<span class="sr-only" style="display:none!important">' + escapeHtml(text) + '</span>';
  }

  function syncLureShieldTitle(item) {
    if (!item || !isJapanese()) return;
    if (!item.classList.contains('product-' + LURESHIELD_HANDLE) &&
      !/LureShield|\u30eb\u30a2\u30fc|\u30b7\u30fc\u30eb\u30c9/i.test(item.textContent || '')) return;

    var title = item.querySelector('.rebuy-cart__flyout-item-product-title') ||
      item.querySelector('.rebuy-cart__flyout-item-title') ||
      item.querySelector('.rebuy-product-title') ||
      item.querySelector('a');

    if (title && title.textContent.trim() !== LURESHIELD_JA_TITLE) {
      title.textContent = LURESHIELD_JA_TITLE;
    }
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); });
  }

  function updateCart(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (response) { return response.json(); });
  }

  function addVariant(quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: LURESHIELD_VARIANT_ID, quantity: quantity }] })
    }).then(function (response) { return response.json(); });
  }

  function setLoading(button, isLoading) {
    var row = button && button.closest('.ra-tier-row');
    if (!row) return;
    row.querySelectorAll('.ra-tier-btn').forEach(function (tierButton) {
      tierButton.disabled = isLoading;
      tierButton.classList.toggle('is-loading', isLoading && tierButton === button);
      tierButton.setAttribute('aria-busy', isLoading && tierButton === button ? 'true' : 'false');
      if (!isLoading) tierButton.removeAttribute('aria-busy');
    });
  }

  function findLureShieldItem() {
    var items = Array.prototype.slice.call(document.querySelectorAll('#rebuy-cart .rebuy-cart__flyout-item'));
    return items.filter(function (item) {
      return item.classList.contains('product-' + LURESHIELD_HANDLE) ||
        /LureShield|\u30eb\u30a2\u30fc|\u30b7\u30fc\u30eb\u30c9/i.test(item.textContent || '');
    })[0] || null;
  }

  function itemHandle(item) {
    var classes = String(item && item.className || '').split(/\s+/);
    for (var index = 0; index < classes.length; index += 1) {
      if (classes[index].indexOf('product-') === 0) return classes[index].replace('product-', '');
    }
    return '';
  }

  function lineQuantity(cart, handle) {
    return (cart.items || []).reduce(function (total, line) {
      return total + (line.handle === handle ? Number(line.quantity || 0) : 0);
    }, 0);
  }

  function lureShieldQuantity(cart) {
    return (cart.items || []).reduce(function (total, line) {
      return total + (
        Number(line.variant_id) === LURESHIELD_VARIANT_ID || line.handle === LURESHIELD_HANDLE
          ? Number(line.quantity || 0)
          : 0
      );
    }, 0);
  }

  function cartItemCount(cart) {
    var lineTotal = (cart.items || []).reduce(function (total, line) {
      return total + Number(line.quantity || 0);
    }, 0);
    return lineTotal || Number(cart.item_count || 0);
  }

  function setQuantityLabel(item, qty) {
    var label = item && item.querySelector('.rebuy-cart__flyout-item-quantity-widget-label');
    if (!label || !qty) return;
    syncLureShieldTitle(item);
    var title = item.querySelector('.rebuy-cart__flyout-item-product-title') ||
      item.querySelector('.rebuy-cart__flyout-item-title') ||
      item.querySelector('a');
    var name = title ? title.textContent.trim() : '';
    var hidden = isJapanese() && name ? name + '\u306e\u6570\u91cf' : 'Quantity' + (name ? ' of ' + name : '');
    label.setAttribute('data-ra-qty', String(qty));
    label.innerHTML = visuallyHiddenText(hidden) + String(qty);
  }

  function syncSubtotalCount(qty) {
    var subtotalLabel = document.querySelector('#rebuy-cart .rebuy-cart__flyout-subtotal-label');
    if (!subtotalLabel || !qty) return;
    subtotalLabel.textContent = isJapanese()
      ? '\u5c0f\u8a08 (' + qty + ' \u70b9)'
      : 'Subtotal (' + qty + ' ' + (qty === 1 ? 'item' : 'items') + ')';
    document.documentElement.setAttribute('data-ra-rebuy-sync-count', String(qty));
  }

  function visibleCartCountWithLureShieldQty(lureShieldQty) {
    return Array.prototype.slice.call(document.querySelectorAll('#rebuy-cart .rebuy-cart__flyout-item')).reduce(function (total, item) {
      if (item.classList.contains('product-' + LURESHIELD_HANDLE)) return total + Number(lureShieldQty || 0);
      var label = item.querySelector('.rebuy-cart__flyout-item-quantity-widget-label');
      var currentQty = parseInt(label && label.innerText, 10);
      return total + (currentQty || 0);
    }, 0);
  }

  function optimisticLureShieldUi(qty) {
    var item = findLureShieldItem();
    if (!item || !qty) return;
    setQuantityLabel(item, qty);
    var discountLine = item.querySelector('.rebuy-cart__flyout-item-discount-line');
    if (discountLine) discountLine.textContent = tierMessage(qty);
    var sale = item.querySelector('.rebuy-cart__flyout-item-price .rebuy-money.sale span:not(.sr-only)');
    var compare = item.querySelector('.rebuy-cart__flyout-item-price .rebuy-money.compare-at span:not(.sr-only)');
    var unitPrice = parseMoneyToCents(compare && compare.textContent) || 100000;
    var discount = tierDiscount(qty);
    if (sale) sale.textContent = money(Math.round(unitPrice * (100 - discount) / 100));
    if (compare) compare.textContent = money(unitPrice);
    syncSubtotalCount(visibleCartCountWithLureShieldQty(qty));
  }

  function quantityForItem(cart, item, itemCount) {
    var handle = itemHandle(item);
    var qty = handle ? lineQuantity(cart, handle) : 0;
    if (handle === LURESHIELD_HANDLE) {
      qty = lureShieldQuantity(cart) || qty || (itemCount === 1 ? cartItemCount(cart) : 0);
    }
    return qty;
  }

  function syncCartChrome(cart) {
    var itemCount = cartItemCount(cart);
    var countText = String(itemCount || 0);
    var subtotalLabel = document.querySelector('#rebuy-cart .rebuy-cart__flyout-subtotal-label');
    if (subtotalLabel) {
      subtotalLabel.textContent = isJapanese()
        ? '\u5c0f\u8a08 (' + countText + ' \u70b9)'
        : 'Subtotal (' + countText + ' ' + (itemCount === 1 ? 'item' : 'items') + ')';
    }

    document.querySelectorAll('.cart-bubble__text-count, [data-testid="cart-bubble"], [data-cart-count], .cart-count').forEach(function (count) {
      if (count.children.length === 0) {
        count.textContent = countText;
        count.classList.toggle('hidden', itemCount === 0);
      }
    });
    document.querySelectorAll('.cart-bubble').forEach(function (bubble) {
      bubble.classList.toggle('visually-hidden', itemCount === 0);
    });

    document.querySelectorAll('.cart-bubble .visually-hidden').forEach(function (hidden) {
      if (isJapanese()) {
        hidden.textContent = '\u30ab\u30fc\u30c8\u5185\u306e\u5408\u8a08\u30a2\u30a4\u30c6\u30e0\u6570: ' + countText;
      } else if (/cart|item/i.test(hidden.textContent || '')) {
        hidden.textContent = 'Total items in cart: ' + countText;
      }
    });
    try {
      window.sessionStorage.setItem('cart-count', JSON.stringify({
        value: countText,
        timestamp: Date.now()
      }));
    } catch (error) {
      document.documentElement.setAttribute('data-ra-rebuy-cart-storage', 'unavailable');
    }
  }

  function syncVisibleCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    var cartItems = document.querySelectorAll('#rebuy-cart .rebuy-cart__flyout-item');
    cartItems.forEach(function (item) {
      var qty = quantityForItem(cart, item, cartItems.length);
      setQuantityLabel(item, qty);
    });
    syncCartChrome(cart);
  }

  var syncTimer = 0;

  function scheduleCartSync(delay) {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(function () {
      getCart().then(syncVisibleCart).catch(function (error) {
        console.warn('[RA Rebuy] Cart label sync failed', error);
      });
    }, delay || 250);
  }

  function bindCartSyncObserver() {
    if (window.__raRebuyCartSyncObserver) return;
    var root = document.querySelector('#rebuy-cart');
    if (!root || typeof MutationObserver === 'undefined') return;
    window.__raRebuyCartSyncObserver = new MutationObserver(function () {
      scheduleCartSync(350);
    });
    window.__raRebuyCartSyncObserver.observe(root, { childList: true, subtree: true });
  }

  function updateVisibleLureShieldLine(cart, qty) {
    var item = findLureShieldItem();
    var matchingLine = (cart.items || []).filter(function (line) {
      return Number(line.variant_id) === LURESHIELD_VARIANT_ID || line.handle === LURESHIELD_HANDLE;
    })[0];

    if (item) {
      syncLureShieldTitle(item);

      var label = item.querySelector('.rebuy-cart__flyout-item-quantity-widget-label');
      if (label) {
        label.setAttribute('data-ra-qty', String(qty));
        label.innerHTML = visuallyHiddenText('Quantity of LureShield') + qty;
      }

      var discountLine = item.querySelector('.rebuy-cart__flyout-item-discount-line');
      if (discountLine) discountLine.textContent = tierMessage(qty);

      var sale = item.querySelector('.rebuy-cart__flyout-item-price .rebuy-money.sale span:not(.sr-only)');
      var compare = item.querySelector('.rebuy-cart__flyout-item-price .rebuy-money.compare-at span:not(.sr-only)');
      if (matchingLine && sale) sale.textContent = money(matchingLine.final_price || matchingLine.discounted_price || matchingLine.price);
      if (matchingLine && compare) compare.textContent = money(matchingLine.original_price || matchingLine.price);
    }

    var finalAmount = document.querySelector('#rebuy-cart .rebuy-cart__flyout-subtotal-final-amount span:not(.sr-only)');
    var compareAmount = document.querySelector('#rebuy-cart .rebuy-cart__flyout-subtotal-compare-amount span:not(.sr-only)');
    if (finalAmount) finalAmount.textContent = money(cart.total_price);
    if (compareAmount) compareAmount.textContent = ' ' + money(cart.original_total_price || cart.items_subtotal_price || cart.total_price);

    document.querySelectorAll('.cart-count, [data-cart-count], .cart-count-bubble span').forEach(function (count) {
      if (count.children.length === 0) count.textContent = cartItemCount(cart);
    });

    syncVisibleCart(cart);
  }

  function setExactQuantity(qty, button) {
    setLoading(button, true);
    optimisticLureShieldUi(qty);
    return getCart()
      .then(function (cart) {
        var updates = {};
        var matches = (cart.items || []).filter(function (line) {
          return Number(line.variant_id) === LURESHIELD_VARIANT_ID || line.handle === LURESHIELD_HANDLE;
        });

        if (!matches.length) return addVariant(qty).then(getCart);

        matches.forEach(function (line, index) {
          updates[line.key] = index === 0 ? qty : 0;
        });
        return updateCart(updates);
      })
      .then(function (cart) {
        updateVisibleLureShieldLine(cart, qty);
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('rebuy:cart.change', { bubbles: true, detail: cart }));
        scheduleCartSync(600);
        window.setTimeout(function () { scheduleCartSync(250); }, 1600);
        return cart;
      })
      .catch(function (error) {
        console.error('[RA Rebuy] LureShield tier button failed', error);
      })
      .finally(function () {
        window.setTimeout(function () { setLoading(button, false); }, 350);
      });
  }

  function handleTierButtonClick(event, button) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    }
    button = button || event && event.currentTarget;
    var qty = parseInt(button && button.getAttribute('data-qty'), 10);
    if (!qty) return false;
    setExactQuantity(qty, button);
    return false;
  }

  window.RASetLSTierQty = handleTierButtonClick;
  window.RAThemeSetLSTierQty = handleTierButtonClick;

  function captureTierButtonClick(event) {
    if (event.__raLureShieldTierHandled) return;
    var button = event.target && event.target.closest && event.target.closest('.ra-tier-btn[data-vid="' + LURESHIELD_VARIANT_ID + '"]');
    if (!button) return;
    event.__raLureShieldTierHandled = true;
    handleTierButtonClick(event, button);
  }

  window.addEventListener('click', captureTierButtonClick, true);
  document.addEventListener('click', captureTierButtonClick, true);

  window.setInterval(function () {
    if (window.RASetLSTierQty !== handleTierButtonClick) {
      window.RASetLSTierQty = handleTierButtonClick;
    }
  }, 1000);

  document.addEventListener('rebuy:smartcart.show', function () {
    bindCartSyncObserver();
    scheduleCartSync(300);
  });
  document.addEventListener('rebuy:smartcart.ready', function () {
    bindCartSyncObserver();
    scheduleCartSync(300);
  });
  document.addEventListener('rebuy:cart.change', function () {
    scheduleCartSync(300);
  });
  document.addEventListener('rebuy:cart.add', function () {
    scheduleCartSync(300);
  });
  document.addEventListener('rebuy:smartcart.line-item-increase', function () {
    scheduleCartSync(300);
  });
  document.addEventListener('rebuy:smartcart.line-item-decrease', function () {
    scheduleCartSync(300);
  });
  document.addEventListener('rebuy:smartcart.line-item-removed', function () {
    scheduleCartSync(300);
  });
  document.addEventListener('ra:cart:synchronized', function () {
    scheduleCartSync(100);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindCartSyncObserver();
      scheduleCartSync(500);
    });
  } else {
    bindCartSyncObserver();
    scheduleCartSync(500);
  }
})();
